
export function escapeHtml(str: string): string {
    const htmlEntities: { [key: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };

    return str.replace(/[&<>'"]/g, (char: string) => htmlEntities[char] || char);
}

export function toHtml(text: string) {
    if (text === undefined) {
        return "";
    }
    return toHtmlBreaks(escapeHtml(text));
}

export function toHtmlBold(text: string) {
    return `<b>${text}</b>`;
}

/**
 * Converts \n, \\n and tabs, etc to some html friendly format. 
 * @param text
 * @return
 */
export function toHtmlBreaks(text: string) {
    if (text === undefined) {
        return "";
    }

    let html = "";
    let i = 0;

    while (i < text.length) {
        let c = text.charAt(i++);

        if (c === '\n') {
            html += "<br>";
        } else if (c === '\\' && i < text.length) {
            let d = text.charAt(i++);

            if (d === 'n') {
                html += "<br>";
            } else if (d === 't') {
                html += "&emsp;"; // 4 spaces
            } else {
                html += c;
                html += d;
            }
        } else if (c === ' ' && i < text.length) {
            let d = text.charAt(i++);
            // convert a double space to a non breaking space followed by a normal space
            if (d === ' ') {
                html += " &nbsp;";
            } else {
                html += c;
                html += d;
            }
        } else {
            html += c;
        }
    }
    return html;
}

export function simpelMDtoHtml(md: string): string {
    const s = escapeHtml(md);
    // transforms - text to <li></li>
    const ultag = "-";
    const strongtag = "**";
    let ret = "";
    const intag = {
        strong: false,
        ulist: false,
        paragraph: false,
    };

    // search line by line
    for (let line of s.split("\n")) {
        // strong
        const strong = line.split(strongtag);

        line = "";
        for (let i = 0; i < strong.length; i++) {
            line += strong[i];

            if (i + 1 < strong.length) {
                if (intag.strong) {
                    line += '</strong>';
                } else {
                    line += '<strong>';
                }
                intag.strong = !intag.strong;
            }
        }

        // lists
        if (line.startsWith(ultag)) {
            if (intag.paragraph) {
                ret += '</p>';
            }
            if (!intag.ulist) {
                intag.ulist = true;
                ret += '<ul class="md">';
            }
            ret += `<li class='md'> ${line.substring(ultag.length)}</li>`;
        } else {
            if (intag.ulist) {
                intag.ulist = false;
                ret += '</ul>';
            }
            if (!intag.paragraph) {
                intag.paragraph = true;
                ret += '<p>';
            }
            // put back the newline
            ret += line + '<br>';
        }
    }
    if (intag.ulist) {
        ret += '</ul>';
    } else if (intag.paragraph) {
        ret += '</p>';
    } else if (intag.strong) {
        ret += '</strong>';
    }
    return ret;
}